/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var CookieHub = /** @class */ (function () {
        function CookieHub() {
        }
        CookieHub.check = function () {
            var _a;
            var ch = (_a = window['cookiehub'], (_a !== null && _a !== void 0 ? _a : null));
            if (ch === null) {
                return false;
            }
            // @ts-ignore
            return !!ch.hasConsented('analytics');
        };
        return CookieHub;
    }());

    var Contact = /** @class */ (function () {
        function Contact() {
        }
        Contact.prototype.initContactEvent = function (form, value) {
            form.addEventListener('submit', function (e) {
                if (CookieHub.check()) {
                    fbq('track', 'Contact', {
                        value: value,
                    });
                }
            });
        };
        Contact.prototype.run = function () {
            var qnForm = document.querySelector('form.storeQnLoginForm');
            if (qnForm) {
                this.initContactEvent(qnForm, 'login');
            }
            var mypageForm = document.querySelector('body.storeMypageAuth form.storeAuthForm');
            if (mypageForm) {
                this.initContactEvent(qnForm, 'login');
            }
            var mypageRegisterForm = document.querySelector('#store form.withPassword');
            if (mypageRegisterForm) {
                this.initContactEvent(mypageRegisterForm, 'register');
            }
        };
        return Contact;
    }());
    var contact = new Contact();
    contact.run();

}());
typeof tsBuild === 'function' && tsBuild();})();
